export default __webpack_public_path__ + "af49375122163b4eb77e7511e94e14b3.png";